/** @format */

import { Col, Form, Layout, Row } from "antd";
import { Footer } from "antd/lib/layout/layout";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { NavLink } from "react-router-dom";
import { API_TASKS } from "../../../constants/api";
import { Colors } from "../../../theme/maps/Colors";
import apiClient from "../../../utils/apiClient";
import { Routes } from "../../../utils/Routes";
import { UIButton } from "../../ui/Button";
import { UIInput } from "../../ui/Input";
import { UIText } from "../../ui/Text";
import { UITitle } from "../../ui/Title";
import { Print } from "react-easy-print";

export const ViewForm = (): JSX.Element => {
  //@ts-ignore
  const { idCliente } = useParams();
  const [cliente, setCliente] = useState({});
  const [fido, setFido] = useState(null);
  const [causali, setCausali] = useState([]);
  const [finalObject, setFinalObject] = useState(null);

  const history = useHistory();

  const handleSend = (values: {}): void => {
    //@ts-ignore
    const data = Array.from(Object.keys(values)).reduce((list, current) => {
      if (current.includes("c-")) {
        //@ts-ignore
        if (!!list && !!list[current.split("-")[1]]) {
          return {
            ...list,
            //@ts-ignore
            [current.split("-")[1]]: {
              //@ts-ignore
              ...list[current.split("-")[1]],
              //@ts-ignore
              [current.split("-")[2]]: values[current]
                ? //@ts-ignore
                  parseFloat(values[current].replace(",", "."))
                : "0",
            },
          };
        } else {
          return {
            ...list,
            //@ts-ignore
            [current.split("-")[1]]: {
              //@ts-ignore
              [current.split("-")[2]]: values[current]
                ? //@ts-ignore
                  parseFloat(values[current].replace(",", "."))
                : "0",
              id_causale: current.split("-")[1],
              id_card: JSON.stringify(0),
              id_cliente: idCliente,
              //@ts-ignore
              targa: values.targa,
              //@ts-ignore
              indirizzo: values.indirizzo,
              //@ts-ignore
              km_mezzo: values.km_mezzo,
            },
          };
        }
      }
    }, {});

    //@ts-ignore
    const newData = Object.values(data).filter(el => el.litri !== "0");
    //@ts-ignore
    setFinalObject(newData);
  };

  useEffect(() => {
    apiClient
      .post(
        "",
        qs.stringify({
          task: API_TASKS.GET_SEARCH,
        }),
      )
      .then(res => {
        //@ts-ignore
        setCliente(res.data.CLIENTI.find(el => el.id === idCliente));
      })
      .catch(er => {
        setCliente(
          JSON.parse(
            '{"ESITO":"OK","CLIENTI":[{"id":"51","ragione_sociale":"NORD ELEVATORS S.R.L"},{"id":"12","ragione_sociale":"Centro medico di ortopedia e Fisiokinesiterapia S.r.l."},{"id":"53","ragione_sociale":"CO.GE.SI"},{"id":"52","ragione_sociale":"LUNETTO "},{"id":"10","ragione_sociale":"Cucinella Giuseppe s.r.l."},{"id":"13","ragione_sociale":"Chimica Noto S.r.l. "},{"id":"48","ragione_sociale":"BADALAMENTI"},{"id":"16","ragione_sociale":"NUOVA EDIL STRADALE S.A.S"},{"id":"17","ragione_sociale":"ISTITUTO DI VIGILANZA EUROPOL S.R.L."},{"id":"18","ragione_sociale":"LA FENICE S.R.L"},{"id":"20","ragione_sociale":"Costruzione Tonnino Giovanni Battista"},{"id":"22","ragione_sociale":"TOAN DI ZITO SALVATORE"},{"id":"23","ragione_sociale":"METAL COSTRUZIONI S.R.L."},{"id":"24","ragione_sociale":"Jcom Telecomunicazioni s.c.a.r.l."},{"id":"25","ragione_sociale":"Chiovaroto Tito"},{"id":"26","ragione_sociale":"BALDARI IMPIANTI S.R.L.S."},{"id":"27","ragione_sociale":"Due F. Trasporti di Farnese F. & C. s.n.c."},{"id":"28","ragione_sociale":"Sciara Stefano"},{"id":"30","ragione_sociale":"SCIANNA"},{"id":"31","ragione_sociale":"PROTEZIONE CIVILE"},{"id":"32","ragione_sociale":"ALECCIA VINCENZO"},{"id":"33","ragione_sociale":"SCIARA GAETANO"},{"id":"35","ragione_sociale":"BENNY ANGELO BLU"},{"id":"36","ragione_sociale":"BRUGNANO S.R.L."},{"id":"49","ragione_sociale":"GIDA s.r.l. "},{"id":"50","ragione_sociale":"CARGO "},{"id":"38","ragione_sociale":"SALUS"},{"id":"47","ragione_sociale":"ORTOSUD DI LOMBARDO"},{"id":"60","ragione_sociale":"NUOVA LUNA "},{"id":"59","ragione_sociale":"INOX"},{"id":"42","ragione_sociale":"CONSORZIO SOCIALE SERVIZI QUALIFICATI ONLUS"},{"id":"56","ragione_sociale":"CORSO VINCENZO"},{"id":"58","ragione_sociale":"CAVA GALATI"},{"id":"54","ragione_sociale":"MONDIALPOL"},{"id":"55","ragione_sociale":"PALAZZOLO COSTRUZIONI"},{"id":"44","ragione_sociale":"CONSORZIO HERA SOCIETA COOPERATIVA SOCIALE ONLUS"},{"id":"57","ragione_sociale":"TIMPA GIANFRANCO"},{"id":"61","ragione_sociale":"RS RAPPA TRASPORTI"},{"id":"62","ragione_sociale":"CS POLICE "},{"id":"63","ragione_sociale":"lo monaco costruzioni "},{"id":"64","ragione_sociale":"TRUE SERVICE"},{"id":"65","ragione_sociale":"BARRETTA PASQUALE "},{"id":"66","ragione_sociale":"CENTRO ORTOPEDICO SANIATRIO FERRO S.A.S"},{"id":"67","ragione_sociale":"PECORELLA GASPARE "},{"id":"68","ragione_sociale":"CRI.MAR"},{"id":"69","ragione_sociale":"DS SERVICE SRL "},{"id":"70","ragione_sociale":"TECNOSYSTEM SRL "}]}',
          )
            .CLIENTI //@ts-ignore
            .find(el => el.id === idCliente),
        );
      });

    apiClient
      .post("", qs.stringify({ task: API_TASKS.GET_FIDO, id: idCliente }))
      .then(res => {
        setFido(res.data.FIDO);
      })
      .catch(e => {
        setFido(JSON.parse('{"ESITO":"OK","FIDO":"4644.97"}').FIDO);
      });

    apiClient
      .post("", qs.stringify({ task: API_TASKS.GET_CAUSALI, id: idCliente }))
      .then(res => {
        setCausali(res.data.CAUSALI);
      })
      .catch(e => {
        setCausali(
          JSON.parse(
            '{"ESITO":"OK","CAUSALI":[{"id":"6","descrizione":"Gasolio","stampa":"1"},{"id":"7","descrizione":"Benzina","stampa":"1"},{"id":"8","descrizione":"Olio","stampa":"1"},{"id":"18","descrizione":"GPL","stampa":"1"}]}',
          ).CAUSALI,
        );
      });
  }, []);

  useEffect(() => {
    console.log(finalObject);
    //@ts-ignore
    if (finalObject && Object.values(finalObject).length) {
      apiClient
        .post(
          "",
          JSON.stringify({
            task: API_TASKS.ADD_MOVIMENTAZIONE,
            json: finalObject,
          }),
        )
        .then(res => {
          window.print();
          history.push(Routes.home);
        });
    }
  }, [finalObject]);
  return (
    <>
      <Layout style={{ padding: "0", height: "100%" }}>
        <Row
          justify="center"
          style={{
            backgroundColor: Colors.background,
          }}
        >
          <Col span={3} style={{ padding: "4px", textAlign: "center" }}>
            <NavLink to={Routes.search}>
              <UITitle level={3} style={{ margin: 0, fontWeight: "bold" }}>
                {"<"}
              </UITitle>
            </NavLink>
          </Col>
          <Col span={18} style={{ padding: "4px", textAlign: "center" }}>
            <UITitle level={4} style={{ margin: 0, paddingTop: "1px", fontWeight: "bold" }}>
              RIFORNIMENTO
            </UITitle>
          </Col>
          <Col span={3}></Col>
        </Row>
        {cliente &&
          //@ts-ignore
          cliente.ragione_sociale && (
            <Row
              style={{
                borderBottom: "2px solid " + Colors.background,
                backgroundColor: Colors.white,
              }}
            >
              <Col span={18} style={{ textAlign: "center", alignSelf: "center" }}>
                <UIText style={{ fontSize: "16px", fontWeight: 800 }}>
                  {
                    //@ts-ignore
                    cliente.ragione_sociale
                  }
                </UIText>
              </Col>
              <Col
                span={6}
                style={{
                  textAlign: "center",
                  padding: "6px 0px",
                  display: "grid",
                  fontSize: "15px",
                  lineHeight: "1.2",
                }}
              >
                <UIText style={{ fontWeight: 800 }}>Fido:</UIText>
                <UIText style={{ fontWeight: 800 }}>
                  {
                    //@ts-ignore
                    fido
                  }
                </UIText>
              </Col>
            </Row>
          )}
        <Row
          justify="center"
          style={{
            backgroundColor: Colors.white,
          }}
        >
          <Col style={{ padding: "3px" }}>
            <UITitle level={5} style={{ margin: 0, fontWeight: 800 }}>
              IMPORTI
            </UITitle>
          </Col>
        </Row>
        <Form
          name="rifornimento"
          onFinish={handleSend}
          onFinishFailed={(e): void => console.log(e)}
          style={{ background: Colors.white }}
        >
          <>
            {!!causali.length &&
              causali.map(el => (
                <Row
                  //@ts-ignore
                  key={el.id}
                  style={{ marginBottom: "2px" }}
                >
                  <Col span={8} style={{ alignSelf: "center", paddingLeft: "10px" }}>
                    <UIText style={{ fontWeight: 800 }}>
                      {
                        //@ts-ignore
                        el.descrizione
                      }
                    </UIText>
                  </Col>
                  <Col span={16} style={{ textAlign: "center", alignSelf: "center" }}>
                    <Row>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: 0, padding: "1px 4px" }}
                          name={
                            //@ts-ignore
                            "c-" + el.id + "-valore"
                          }
                        >
                          <UIInput
                            style={{ textAlign: "center", height: "28px" }}
                            type="text"
                            placeholder="IMPORTO"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: 0, padding: "1px 4px" }}
                          name={
                            //@ts-ignore
                            "c-" + el.id + "-litri"
                          }
                        >
                          <UIInput
                            style={{ textAlign: "center", height: "28px" }}
                            type="text"
                            placeholder="LITRI"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ))}
            <Row style={{ borderTop: "2px solid " + Colors.background }}>
              <Col span={24} style={{ textAlign: "center", padding: "2px" }}>
                <UITitle level={5} style={{ margin: 0, fontWeight: 800 }}>
                  INFORMAZIONI
                </UITitle>
              </Col>
            </Row>
            <Row style={{ marginTop: "2px" }}>
              <Col span={12} style={{ alignSelf: "center", paddingLeft: "10px" }}>
                <UIText style={{ fontWeight: 800, fontSize: "15px" }}>TARGA:</UIText>
              </Col>
              <Col span={12} style={{ textAlign: "center", alignSelf: "center" }}>
                <Form.Item
                  style={{ marginBottom: 0, padding: "2px 4px" }}
                  rules={[{ required: true, message: "" }]}
                  name="targa"
                >
                  <UIInput style={{ textAlign: "center", height: "30px" }} placeholder="TARGA" />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: "2px" }}>
              <Col span={12} style={{ alignSelf: "center", paddingLeft: "10px" }}>
                <UIText style={{ fontWeight: 800, fontSize: "15px" }}>KM:</UIText>
              </Col>
              <Col span={12} style={{ textAlign: "center", alignSelf: "center" }}>
                <Form.Item
                  style={{ marginBottom: 0, padding: "2px 4px" }}
                  rules={[{ required: true, message: "" }]}
                  name="km_mezzo"
                >
                  <UIInput style={{ textAlign: "center", height: "30px" }} placeholder="KM" />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: "2px" }}>
              <Col span={12} style={{ alignSelf: "center", paddingLeft: "10px" }}>
                <UIText style={{ fontWeight: 800, fontSize: "15px" }}>NOME:</UIText>
              </Col>
              <Col span={12} style={{ textAlign: "center", alignSelf: "center" }}>
                <Form.Item
                  style={{ marginBottom: 0, padding: "2px 4px" }}
                  rules={[{ required: true, message: "" }]}
                  name="indirizzo"
                >
                  <UIInput style={{ textAlign: "center", height: "30px" }} placeholder="NOME" />
                </Form.Item>
              </Col>
            </Row>
            <Footer style={{ padding: "10px", backgroundColor: Colors.white }}>
              <Row>
                <Col span={24} style={{ textAlign: "center" }}>
                  <Form.Item wrapperCol={{ span: 24 }} style={{ marginBottom: 0 }}>
                    <UIButton
                      style={{ minHeight: "46px", fontWeight: "bold", fontSize: "20px" }}
                      bgColor={Colors.background}
                      color={Colors.black}
                      hoverBgColor={Colors.background}
                      borderColor={Colors.background}
                      htmlType="submit"
                      fullWidth
                    >
                      INVIA
                    </UIButton>
                  </Form.Item>
                </Col>
              </Row>
            </Footer>
          </>
        </Form>
      </Layout>
      {!!finalObject && !!cliente && (
        <Print printOnly name="test">
          <>
            <Row>
              <Col span={24}>
                <UIText>
                  {
                    //@ts-ignore
                    cliente.ragione_sociale
                  }
                </UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UIText>
                  Targa:
                  {
                    //@ts-ignore
                    " " + finalObject[0].targa
                  }
                </UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UIText>
                  KM:
                  {
                    //@ts-ignore
                    " " + finalObject[0].km_mezzo
                  }
                </UIText>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <UIText>
                  Nome:
                  {
                    //@ts-ignore
                    " " + finalObject[0].indirizzo
                  }
                </UIText>
              </Col>
            </Row>
            <Row>
              <Col>-------</Col>
            </Row>
            {
              //@ts-ignore
              finalObject.map(el => (
                <div key={el.id_causale}>
                  <Row>
                    <Col>
                      {
                        //@ts-ignore
                        causali.find(c => c.id == el.id_causale).descrizione
                      }
                      :
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      Importo:
                      {
                        //@ts-ignore
                        " " + el.valore
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      Litri:
                      {
                        //@ts-ignore
                        " " + el.litri
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col>-------</Col>
                  </Row>
                </div>
              ))
            }
          </>
        </Print>
      )}
    </>
  );
};
